import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { isValidDate } from '@utils/date';
import Modal from '@components/ResponsiveModal';
import SimpleButton, { COLOR, SIZE } from '@components/SimpleButton';
import DateInput from '@components/DateInput';
import Footer from './components/Footer';
import Container from './components/Container';
import Subtitle from './components/Subtitle';
import Title from './components/Title';

import messages from './messages';

const onCloseDefault = () => {};

const Button = styled(SimpleButton)`
  width: 107px;
`;

function AgeValidationModal({
  onAccept,
  onClose,
  open,
  intl: { formatMessage },
  message,
}) {
  const modalClasses = { modal: 'modal' };

  const [date, setDate] = useState('');
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  const onAcceptModal = useCallback(() => {
    if (isValidDate(date)) {
      onAccept(date);
      setDate('');
    } else {
      setShowErrorMessage(true);
    }
  }, [date, onAccept]);

  const onCloseModal = useCallback(() => {
    setDate('');
    onClose();
  }, [onClose]);

  const onCleanInput = useCallback(() => {
    setDate('');
    setShowErrorMessage(false);
  }, [setShowErrorMessage]);

  return (
    <Modal
      center
      classNames={modalClasses}
      showCloseIcon={false}
      onClose={onCloseModal}
      open={open}
    >
      <Container>
        <Title>{formatMessage(messages.title)}</Title>
        <Subtitle>{message}</Subtitle>
        <DateInput
          value={date}
          label={formatMessage(messages.inputTitle)}
          onChange={setDate}
          onClean={onCleanInput}
          showErrorMessage={showErrorMessage}
        />
        <Footer>
          <Button
            elementId="ageValidationModal__secondOption"
            label={formatMessage(messages.acceptButton)}
            color={COLOR.PRIMARY}
            onClick={onAcceptModal}
            disabled={!date || date.length !== 10}
            size={SIZE.MEDIUM}
          />
        </Footer>
      </Container>
    </Modal>
  );
}

AgeValidationModal.propTypes = {
  onAccept: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  intl: intlShape,
  message: PropTypes.string,
};

AgeValidationModal.defaultProps = {
  onClose: onCloseDefault,
};

export default injectIntl(AgeValidationModal);
